import './portfolio.scss'


function Portfolio() {
    const handleClick = () => {
        window.open("https://www.linkedin.com/in/hirakdebnath/");
        // 
      };
const amazonClick = () => {
    window.open("https://clone-3bdc1.web.app/");
};
const tictokClick = () => {
    window.open("https://tic-tok-8cf8a.web.app/");
};
const youTube = () => {
    window.open("https://www.youtube.com/channel/UCqzzOLRLz7kuozk3leNlEig/");
};

const fbas = () => {
    window.open("https://drive.google.com/file/d/1bxFSL8_eqW5aeF3CMhqUkuHcS6U1eToW/view?usp=sharing");
};
const ecom = () => {
    window.open("https://drive.google.com/file/d/1naOWAI5lpu7dJ5MxyBlIS3D2RTUfY_0t/view?usp=sharing");
};

const gads = () => {
    window.open("https://drive.google.com/file/d/1d7KT3kaas4CcppUEKKNCW4D2-knqLNAj/view?usp=sharing");
};



    return (
        <div className='portfolio' id="portfolio">
        <h1>Featured Projects</h1>
        <div className="container">
        <div className="item">
          <img src="assets/amazon.PNG" alt="" onClick={amazonClick}/>
          <h3>Amazon Clone </h3>  
        </div>
        <div className="item">
          <img src="assets/tictok.PNG" alt="" onClick={tictokClick}/>
          <h3>Tic Tok Clone </h3>  
        </div>
        <div className="item">
          <img src="assets/physiocross.PNG" alt="" onClick={ecom}/>
          <h3>E-commerce</h3>  
        </div>
        <div className="item">
          <img src="assets/facebookad.PNG" alt="" onClick={fbas}/>
          <h3>Facebook Ads </h3>  
        </div>
        <div className="item">
          <img src="assets/googleads.PNG" alt="" onClick={gads} />
          <h3>Google Ads </h3>  
        </div>
        <div className="item">
          <img src="assets/WATERMARK.png" alt="" onClick={youTube}/>
          <h3>Bright Smilee </h3>  
        </div>
        

        </div>
      <div className="wrapper">
      <h2>
          View Complete Portfolio
      </h2>
      <img  src="assets/down.png" alt="" className="down"/>
      <img className="hero" src="assets/LinkedinLogo.png"alt="" onClick={handleClick} />

      </div>
                 
            
             
</div>

          

        
      


 )


}


export default Portfolio


